import React, { useState, Fragment } from 'react';
import { useSelector } from 'react-redux';
import cx from 'classnames';
import Proptypes from 'prop-types';

import Logo from 'components/common/Logo';
import Loggerbar from 'components/Layout/Loggerbar';
import SidebarMenu from 'components/Layout/SidebarMenu';

import routes from 'routes';

import './styles.scss';

const Sidebar = ({ loggerName }) => {
  const [opened, setOpened] = useState(false);

  const currentLogger = useSelector(state => state.global.currentLogger);

  const toggleSidebar = () => {
    setOpened(!opened);
  };

  /**
   * Sidebar menus definition.
   */
  const menus = [
    {
      title: 'Dashboard',
      links: [
        { title: 'Activity', link: routes.activity.ref(currentLogger) },
        { title: 'Performance', link: routes.performance.ref(currentLogger) },
        { title: 'Live Sessions', link: routes.liveSessions.ref(currentLogger) },
        { title: 'Requesters', link: routes.requesters.ref(currentLogger) },
        { title: 'Networks', link: routes.networks.ref(currentLogger) },
      ],
    },
    {
      title: 'General',
      links: [
        { title: 'Logs', link: routes.logs.ref(currentLogger) },
        { title: 'Bots', link: routes.bots.ref(currentLogger) },
        { title: 'Blacklist', link: routes.blacklist.ref(currentLogger) },
        { title: 'Whitelist', link: routes.whitelist.ref(currentLogger) },
      ],
    },
    {
      title: 'Options',
      links: [
        { title: 'Keys', link: routes.keys.ref(currentLogger) },
        { title: 'Groups', link: routes.groups.ref(currentLogger) },
        { title: 'Crawlers', link: routes.crawlers.ref(currentLogger) },
        { title: 'Stopwords', link: routes.stopwords.ref(currentLogger) },
        { title: 'Settings', link: routes.settings.ref(currentLogger) },
      ],
    }
  ];

  /**
   * Returns menus
   * as SidebarMenu components.
   */
  const getMenus = () => {
    return menus.map((menu, i) => {
      return (
        <SidebarMenu
          key={i}
          title={menu.title}
          links={menu.links}
        />
      );
    });
  };

  return (
    <Fragment>
      <div className="sidebar-hamburguer" onClick={toggleSidebar}>
        <span className="icon is-large">
          <i className="fas fa-lg fa-bars"></i>
        </span>
      </div>
      <div className={cx('sidebar', { opened })}>
        <div className="sidebar-header">
          <Logo dark />
        </div>
        <div className="sidebar-split">
          <Loggerbar />
          <div className="sidebar-content">
            <div className="sidebar-title">
              {loggerName}
            </div>
            {getMenus()}
          </div>
        </div>
      </div>
      <div
        className={cx('sidebar-cover', { opened })}
        onClick={toggleSidebar}
      />
    </Fragment>
  );
};

Sidebar.propTypes = {
  loggerName: Proptypes.string,
};

export default Sidebar;
